// ##### 24-09-09 Komarov
import parse from 'html-react-parser';
// ##### Komarov 2025-07-23
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// ##### 25-05-21 Komarov
import OccupancyRates from '../OccupancyRates.jsx';
// ##### 25-01-22 Komarov
import { getTourContents } from '../../../../../Redux/actions/index.js';
// ##### 23-09-14 Komarov
// import 'antd/dist/antd.css';
// ##### 25-05-21 Komarov
import Moon from '../../../../Library/Icons/moon.jsx';
import Sun from '../../../../Library/Icons/sun.jsx';
import { useWindowWidthAndHeight } from '../../../Helpers/WindowResizeHook.js';
// ##### 23-04-12 Komarov
import uniqueId from 'lodash.uniqueid';
import DivTag from './DivTag.jsx';
// ##### 25-01-14 Komarov
import { getPostObject, getUrl } from '../../../../../helpers/crypto.js';
// ##### 26-07-30 Komarov
import { smartApiGet, smartApiPost } from '../../../../../helpers/smartApiPost';
// ##### 25-04-30 Komarov
import { uniLog } from '../../../../../../server/helpers/uniLog.js';
// ##### 25-05-10 Komarov
import useValidateQuery from '../../../../../helpers/useValidateQuery.js';

// ##### Komarov 2025-07-14
const TourDetails = () => {
  // ##### Komarov 2025-07-12
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // ##### 23-12-27 Komarov
  const locale = useSelector(state => state.language);
  const dispatch = useDispatch();

  const choiceDetailsNew = useSelector(
    state => state.tourcontents.tourcontents
  );
  // ##### 25-05-10 Komarov
  const search_data = useValidateQuery();

  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### 25-04-30 Komarov
    uniLog(
      'axios:src/Components/Pages/ThirdPageofSearchModule/Tours/TourDetails.jsx:getTourContents(search_data.tour_id, search_data.selection)'
    );
    // ##### Komarov 2025-07-21
    dispatch(getTourContents(search_data?.tour_id, search_data?.selection));
    // ##### 23-04-12 Komarov
  }, [dispatch, search_data?.tour_id, search_data?.selection]);

  let mappingExists;
  let hotelsExist;

  // ##### 24-03-21 Komarov
  for (const key in choiceDetailsNew[0]) {
    if (key.includes('mapping')) {
      if (choiceDetailsNew[0][key].join('').includes('no mapping hotels')) {
        mappingExists = 'false';
      } else mappingExists = 'true';
    }
  }
  // ##### 24-03-21 Komarov
  for (const key in choiceDetailsNew[0]) {
    if (key.includes('hotels')) {
      if (choiceDetailsNew[0][key].join('').includes('no attached hotels')) {
        hotelsExist = 'false';
      } else hotelsExist = 'true';
    }
  }

  const [details, setDetails] = useState([{}]);
  const [rateDetails, setrateDetails] = useState([{}]);
  const [selectionDetails, setSelection] = useState(search_data?.selection);
  const [filteredDetails, setfilteredDetails] = useState([{}]);
  const [open, setOpen] = useState(false);

  // ##### 23-04-12 Komarov
  const [/* width, */ height] = useWindowWidthAndHeight();

  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### 25-04-30 Komarov
    uniLog(
      'axios:src/Components/Pages/ThirdPageofSearchModule/Tours/TourDetails.jsx:TourDetails'
    );
    const url = getUrl(
      'content',
      `id=${search_data?.tour_id}&language=${locale}`
    );
    // ##### 25-04-30 Komarov
    uniLog(
      'axios:src/Components/Pages/ThirdPageofSearchModule/Tours/TourDetails.jsx:useEffect, url:',
      url
    );
    // ##### 26-07-30 Komarov
    smartApiGet(url)
      .then(res => {
        setDetails(res.data);
      })
      .catch(error => {
        setDetails(undefined);
        console.error('[axios error] : ', error);
      });
  }, [locale, search_data?.tour_id]);

  // console.log('[DETAILED CONTENT]', details)
  const { user: currentUser } = useSelector(state => state.auth);
  // ##### 24-03-01 Komarov
  const company_cipher = useSelector(state => state.whitelabel.company_cipher);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    const data = {
      // ##### 25-02-12 Komarov
      company_cipher: company_cipher || '',
      city_id: search_data?.city_id,
      // date: currentMonth === search_data.date ? today : (search_data.date + '-01'),
      date: search_data?.selection,
      window: 30,
      tour_id: search_data?.tour_id,
    };

    const postObject = getPostObject({
      action: 'GetPriceTourRQ',
      user_id: currentUser.user_id,
      refpartner: currentUser.company_id,
      language: locale,
      data,
    });

    // ##### 26-07-30 Komarov
    smartApiPost(postObject.url, postObject.parameters)
      .then(res => {
        setrateDetails(res.data);
      })
      .catch(error => {
        setrateDetails(undefined);
        console.error('[axios error] : ', error);
      });
  }, [
    currentUser.user_id,
    search_data?.city_id,
    search_data?.selection,
    search_data?.tour_id,
    company_cipher,
  ]);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    const data = {
      // ##### 25-02-12 Komarov
      company_cipher: company_cipher || '',
      city_id: search_data?.city_id,
      // date: currentMonth === search_data.date ? today : (search_data.date + '-01'),
      date: search_data?.selection,
      window: 30,
      tour_id: search_data?.tour_id,
    };

    const postObject = getPostObject({
      action: 'GetPriceTourRQ',
      user_id: currentUser.user_id,
      refpartner: currentUser.company_id,
      language: locale,
      data,
    });

    // ##### 26-07-30 Komarov
    smartApiPost(postObject.url, postObject.parameters)
      .then(res => {
        const filtered = res.data[0].rate.filter(
          (item1, index, array) =>
            array.findIndex(t => t.date === item1.date) === index
        );

        setfilteredDetails(filtered);
      })
      .catch(error => {
        setfilteredDetails(undefined);
        console.error('[axios error] : ', error);
      });
  }, [
    currentUser.user_id,
    search_data?.city_id,
    search_data?.selection,
    search_data?.tour_id,
    company_cipher,
  ]);

  function selectedPeriod(value) {
    setSelection(value);
  }

  const MakeVisible = () => {
    setOpen(!open);
  };

  return (
    <div className="TourDetailsWrapper" data-component="TourDetails">
      <h2 style={{ marginTop: '4vh' }}>
        {search_data?.tour_name.replace(/%20/g, ' ')}
      </h2>
      <div className="Icons">
        <Sun />

        <div style={{ marginLeft: '0.4vw' }}>
          {rateDetails[0].duration} days
        </div>

        <div style={{ marginLeft: '0.4vw', marginRight: '0.4vw' }}> - </div>

        <Moon />

        <div style={{ marginLeft: '0.4vw' }}>
          {' '}
          {rateDetails[0].duration - 1} nights{' '}
        </div>
      </div>

      {/* ##### 23-04-20 Komarov */}
      <DivTag
        className="greaterThan-desktopMinWidth_1024 TourDetailsInner"
        width="60%"
        details={details}
        height={height}
        rateDetails={rateDetails}
        selectionDetails={selectionDetails}
        search_data={search_data}
        choiceDetailsNew={choiceDetailsNew}
        MakeVisible={MakeVisible}
        selectedPeriod={selectedPeriod}
        filteredDetails={filteredDetails}
      />
      <DivTag
        className="lessThanOrEqual-desktopMinWidth_1024 TourDetailsInnerSmallScreen"
        width="100%"
        details={details}
        height={height}
        rateDetails={rateDetails}
        selectionDetails={selectionDetails}
        search_data={search_data}
        choiceDetailsNew={choiceDetailsNew}
        MakeVisible={MakeVisible}
        selectedPeriod={selectedPeriod}
        filteredDetails={filteredDetails}
      />

      <div className="CostBreakdown">
        <h3>Cost breakdown</h3>
        <OccupancyRates
          // choiceDetailsNew={choiceDetailsNew}
          // hotelChoice={hotelChoice}
          selectionDetails={selectionDetails}
          tour_id={search_data?.tour_id}
          // totalPax={AmountPax}
          choiceDetailsNew={choiceDetailsNew}
          mappingExists={mappingExists}
          hotelsExist={hotelsExist}
          pickedCurrency={search_data?.selected_currency}
        />
      </div>

      <div>
        {
          // ##### 24-03-21 Komarov
          details?.map(item => {
            if (item.content_name === 'Body') {
              return (
                // ##### 23-04-12 Komarov
                <div key={uniqueId()} className="DescriptionTourDetails">
                  {/* ##### 23-10-10 Komarov: TODO: взять перевод из Смарта */}
                  <h3>Tour Itinerary</h3>
                  {parse(item.text)}
                </div>
              );
            }
          })
        }
      </div>
    </div>
  );
};

export default TourDetails;
